import { gql } from 'graphql-request';

export const ACCEPT_STAFF_INVITE = gql`
  mutation CoreEmployeeInvitations($invitationId: ID!) {
    coreEmployeeInvitations {
      acceptInvitation(input: { invitationId: $invitationId, isAccepted: true })
    }
  }
`;
